/**
 * calls fn immediately in normal navigation, or defers it until the page activates
 * if we're currently in a prerender context
 *
 * use this to guard any analytics or side-effect calls that shouldn't fire
 * before the user has actually landed on the page
 */
export function deferIfPrerendering(fn: () => void): void {
    if ('prerendering' in document && document.prerendering) {
        document.addEventListener('prerenderingchange', fn, { once: true });
    } else {
        fn();
    }
}
